import { textCase } from "shared/utilities";

export type LanguageSlug = keyof typeof Language.values;

export class Language {
  public static readonly values = {
    "danish": {
      name: "Dansk",
      value: 1
    },
    "english": {
      name: "Engelsk",
      value: 2
    }
  };

  public static languageFromJSON(value: number) : Language
  {
    if (value === 1)
    {
      return new Language("danish");
    } else if (value === 2)
    {
      return new Language("english");
    }

    return new Language("danish")
  }

  public static readonly selectableValues = [
    new Language("danish"),
    new Language("english")
  ];

  public constructor(slug: LanguageSlug) {
    this.slug = textCase(slug, "pascal", "kebab") as any;
    Object.assign(this, Language.values[this.slug]);
  }

  public slug: LanguageSlug;
  public name: string;
  public value: number;
}
